import { PlannerEcsSystem } from '@inter-ikea-storageone/range';
import RequestUprightsComponent from '../components/RequestUprightsComponent';
import { addSection } from '../functions/uprightPlacement';
export class PopulateUprightSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'PopulateUprightSystem', RequestUprightsComponent.id);
    }
    onAdd(entity, _newComponent) {
        addSection(this.coreApi, entity, _newComponent);
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=PopulateUprightSystem.js.map